import { call, put, take, select, actionChannel, takeEvery } from 'redux-saga/effects'
import { get } from 'lodash'

import {
  requestRefund,
  requestRefundSucceeded,
  requestRefundFailed,
  SYNC_REFUND_REQUESTED,
} from '../actions/refund'

import { makeGetRefund } from '../selectors/refund'
import MutationApi from '../remote/mutationApi'
import { toast } from 'react-toastify'
import Log from '../utils/Log'


export function* refundOrder(params = {}) {
  const orderId = get(params, 'payload.orderId', '')
  const lineItemUuids = get(params, 'payload.lineItemIds', [])
  const reason = get(params, 'payload.reason', 'unknown')
  const consumed = get(params, 'payload.isComp', false)
  const endpoint = MutationApi.refundOrderItems
  let callParams = [endpoint, orderId, reason, lineItemUuids, consumed]

  try {
    const result = yield call.apply(null, callParams)
    const applied = result?.data?.orderMutations?.[0]?.applied
    if (applied) {
      yield put(requestRefundSucceeded(orderId, result))
    } 
  } catch (err) {
    const errorMessage = err?.response?.data?.errorMessage ?? "Sorry, but something went wrong"
    yield handleError(errorMessage, orderId, lineItemUuids, reason, err)
  }
}

export function* watchRefundOrder() {
  yield takeEvery(requestRefund.type, refundOrder)
}

function* syncRefundOrder(action) {
  const orderId = get(action, 'payload.orderId', '')
  const getRefund = makeGetRefund()
  const refund = yield select(getRefund, orderId)

  yield put(requestRefund(refund))
}

export function* watchSyncRefunds() {
  const queue = yield actionChannel(SYNC_REFUND_REQUESTED)

  while (true) {
    const payload = yield take(queue)

    yield call(syncRefundOrder, payload)
  }
}

function* handleError(errorMessage, orderId, lineItemUuids, reason, err = {}) {
  Log.error('Refund failed', {
    errorMessage,
    orderId,
    lineItemUuids,
    reason,
  })

  yield put(requestRefundFailed(orderId, err))
}
